import type { RouteRecordRaw } from "vue-router";

// These are the routes which are currently redirected to an iframe.
// This list will shrink as more Mobius functionality will be migrated to the REST API.
const iframeRoutes: RouteRecordRaw[] = [
  {
    path: "/redirect_with_access",
    name: "iframe-redirect-with-access",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/admin/tasks",
    name: "iframe-admin-tasks",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/admin/deprecated_tasks",
    name: "iframe-admin-deprecated_tasks",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/admin/scheduled_jobs",
    name: "iframe-admin-scheduled-jobs",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/admin/scheduled_modules",
    name: "iframe-admin-scheduled-modules",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/admin/tasks/:task_id/log",
    name: "iframe-admin-task-log",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/admin/tasks/:task_id/requests",
    name: "iframe-admin-task-requests",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/admin/tasks/:task_id",
    name: "iframe-admin-task",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/accounting_configuration/tenant_id/:tenant_id/configuration_id/:config_id",
    name: "iframe-user-accounting-config",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/accounting_configuration/tenant_id/:tenant_id/configuration_id/:config_id/defaults",
    name: "iframe-user-accounting-config-default",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/accounting_configuration/tenant_id/:tenant_id/configuration_id/:config_id/qbo_preferences",
    name: "iframe-user-accounting-config-qbo_preferences",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/accounting_configuration/:config_id/tasks/:page/:per_page",
    name: "iframe-user-accounting-config-tasks-per-page",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/batch_status/:task_id",
    name: "iframe-user-batch_status-legacy-by-task",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/batch_status/tenant_id/:tenant_id/task_id/:task_id",
    name: "iframe-user-batch_status-by-task",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/batch_status/tenant_id/:tenant_id",
    name: "iframe-user-batch_status",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/batch_status/tenant_id/:tenant_id/page/:page/page_size/:per_page",
    name: "iframe-user-batch_status-per-page",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/batch_status_rendered/tenant_id/:tenant_id/task_id/:task_id",
    name: "iframe-user-batch_status_rendered",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/batch_status_rendered/tenant_id/:tenant_id/task_id/:task_id",
    name: "iframe-user-batch_status_rendered",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/connectwise_configuration/tenant_id/:tenant_id",
    name: "iframe-user-connectwise-configuration",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/connectwise_configuration/tenant_id/:tenant_id/products/:match",
    name: "iframe-user-connectwise-configuration-products",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/create_expense_batch/tenant_id/:tenant_id",
    name: "iframe-user-create_expense_batch",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/create_inventory_batch/tenant_id/:tenant_id",
    name: "iframe-user-create_inventory_batch",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/create_invoice_batch/tenant_id/:tenant_id",
    name: "iframe-user-create_invoice_batch",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/create_sync_all_batch/tenant_id/:tenant_id",
    name: "iframe-user-create_sync_all_batch",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/get_unposted_expenses/tenant_id/:tenant_id",
    name: "iframe-user-get-unposted-expenses",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/get_unposted_inventories/tenant_id/:tenant_id",
    name: "iframe-user-get-unposted-inventories",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/get_unposted_invoices/tenant_id/:tenant_id",
    name: "iframe-user-get-unposted-invoices",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/accounting_configuration/tenant_id/:tenant_id/new",
    name: "iframe-user-accounting-config-new",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/accounting_configuration/tenant_id/:tenant_id/configuration_id/:config_id/tax_exempt_products",
    name: "iframe-user-accounting-config-tax_exempt_products",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/accounting_configuration/tenant_id/:tenant_id/configuration_id/:config_id/tax_code_mapping",
    name: "iframe-user-accounting-config-tax_code_mapping",
    component: () => import("@/views/CatchAllView.vue"),
  },
  {
    path: "/user/batch_status/tenant_id/:tenant_id/task_id/:task_id/log",
    name: "iframe-user-batch_status-task-log",
    component: () => import("@/views/CatchAllView.vue"),
  },
];

export default iframeRoutes;
